module.exports = __webpack_public_path__ + "static/media/event-logo.89b95b4a.png";